import { ISnowplowContext } from '@mindtickle/snowplow-client/lib/core/interfaces/tracker';

export function getCompanyContext(company: any) {
  return {
    schema: 'iglu:com.mindtickle.platform/Company/jsonschema/1-0-1',
    data: {
      id: company?.id,
      name: company?.name,
      learning_site_type: company?.companyType,
      learning_site: company?.learningSite || window.location.host,
      org_id: company?.orgId,
      in_iframe: window.self.location !== window.top?.location,
      design: 'new',
    },
  } as ISnowplowContext;
}
